module.exports = "/_next/static/images/Juan_Francisco_Nin-d21a93bf80e39fc3f13e4f008a1b5630.webp";